import React from "react";
import PropTypes from 'prop-types';
import {Checkbox, Tooltip} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(() => ({
    legend: {
        position: 'relative',
        fontWeight: 'bold',
        padding: 0,
        width: '100%'
    },
    refreshDataBtn: {
        padding: 0,
        position: 'absolute',
        right: 5,
        bottom: 0,
        background: 'white'
    },
}));

const Legend = (props) => {
    const {
        sourceColumns, columns, data,
        onSelectAll, getColumns
    } = props;
    const classes = useStyles();
    return (
        <legend className={classes.legend}>
            {sourceColumns.length ? (
                <Tooltip title={'Select All'}>
                    <Checkbox
                        size={"small"}
                        indeterminate={columns.length > 0 && columns.length < sourceColumns.length}
                        checked={columns.length > 0 && columns.length === sourceColumns.length}
                        onChange={onSelectAll}
                        style={{padding: 0, marginRight: 5}}
                        color={"primary"}
                    />
                </Tooltip>
            ) : <></>}
            Source Columns
            {sourceColumns.length ? (
                <Tooltip title={'Refresh Columns'}>
                    <IconButton className={classes.refreshDataBtn} style={{padding: 0}}
                                onClick={() => getColumns(data.source)}>
                        <Icon style={{padding: 0}}>
                            refresh
                        </Icon>
                    </IconButton>
                </Tooltip>
            ) : <></>}
        </legend>
    )
};

export default Legend

Legend.propTypes = {
    columns: PropTypes.array,
    sourceColumns: PropTypes.array,
    onSelectAll: PropTypes.func,
    getColumns: PropTypes.func,
    data: PropTypes.object
};
